require('./core');

require('./builders/profile_builder');
require('./commands/load_student_profile_command');
require('./models/profile_model');



// WEBPACK FOOTER //
// ./app/lib/authentication/main.ts